import Vue from 'vue';
import Router from 'vue-router';
// import EventBus, { EventName } from '@/utils/EventBus';

import Index from '@/pages/home';
// account
/* eslint-disable */
const Login = resolve => require(['@/pages/account/Login'], resolve);
const SignUp = resolve => require(['@/pages/account/SignUp'], resolve);
// const CheckPhone = resolve => require(['@/components/signUp/CheckPhone'], resolve);
// const InputInfo = resolve => require(['@/components/signUp/InputInfo'], resolve);
// const SignUpDone = resolve => require(['@/components/signUp/SignUpDone'], resolve);
// product
const ProductList = resolve => require(['@/pages/product/List'], resolve);
const ProductDetail = resolve => require(['@/pages/product/Detail'], resolve);
const CompareProductDetail = resolve => require(['@/pages/product/CompareProductDetail'], resolve);
const Certificate = resolve => require(['@/pages/Certificate'], resolve);
const InvoiceDetails = resolve => require(['@/pages/invoiceDetails'], resolve);

const Logistics = resolve => require(['@/pages/logistics'], resolve);
const Solution = resolve => require(['@/pages/solution'], resolve);
const SolutionDetail = resolve => require(['@/pages/solution/Detail'], resolve);
const Search = resolve => require(['@/pages/Search'], resolve);
const ForgetPassword = resolve => require(['@/pages/forgetPassword'], resolve);
// merchant
const Merchant = resolve => require(['@/pages/merchant'], resolve);
const Rate = resolve => require(['@/pages/rate'], resolve);
const BusinessContact = resolve => require(['@/pages/BusinessContact'], resolve);
// industry
const Industry = resolve => require(['@/pages/Industry'], resolve);
const IndustryDetail = resolve => require(['@/pages/Industry/details'], resolve);
const SolutionDetails = resolve => require(['@/pages/Industry/solutionDetails'], resolve);
const IndustryEquipmentDetail = resolve => require(['@/pages/Industry/IndustryEquipmentDetail'], resolve);


const About = resolve => require(['@/pages/About'], resolve);
const News = resolve => require(['@/pages/About/News'], resolve);
const Topic = resolve => require(['@/pages/topic'], resolve);
const Help = resolve => require(['@/pages/help'], resolve);
// shoppingCart
const ShoppingCart = resolve => require(['@/pages/shoppingCart'], resolve);
// const ShoppingCart = resolve => require(['@/pages/shoppingCart'], resolve);
// activity
const Activity = resolve => require(['@/pages/activity'], resolve);
// brand
const Brand = resolve => require(['@/pages/brand'], resolve);
const BrandDetail = resolve => require(['@/pages/brand/detail'], resolve);
// order
const PlaceOrder = resolve => require(['@/pages/order/PlaceOrder'], resolve);
// const QuickOrder = resolve => require(['@/pages/order/QuickOrder'], resolve);
// agreementProduct
const AgreementProduct = resolve => require(['@/pages/agreementProduct'], resolve);
// payment
const Pay = resolve => require(['@/pages/payment/Pay'], resolve);
const PayDone = resolve => require(['@/pages/payment/PayDone'], resolve);
const PayOffline = resolve => require(['@/pages/payment/PayOffline'], resolve);
// other
const Freeback = resolve => require(['@/pages/other/Freeback'], resolve);
// SelfOffer
const SelfOffer = resolve => require(['@/pages/selfOffer'], resolve);
// SubmitOrder
const SubmitOrder = resolve => require(['@/pages/submitOrder'], resolve);
// findProduct
const FindProduct = resolve => require(['@/pages/findProduct'], resolve);
const FindProductList = resolve => require(['@/pages/findProductList'], resolve);
// profile
const Profile = resolve => require(['@/pages/profile'], resolve);
const MyReceiveInfo = resolve => require(['@/components/profile/Address/MyReceiveInfo'], resolve);
const Personal = resolve => require(['@/components/profile/Personal/Personal'], resolve);
const BasicInfomation = resolve => require(['@/components/profile/Personal/BasicInfomation'], resolve);
const Coupon = resolve => require(['@/components/profile/Coupon/Coupon'], resolve);
const MyInvoiceInfo = resolve => require(['@/components/profile/Address/MyInvoiceInfo'], resolve);
const MyOrder = resolve => require(['@/components/profile/ShoppingOrder/MyOrder'], resolve);
const ViewOrderDetail = resolve => require(['@/components/profile/ShoppingOrder/ViewOrderDetail'], resolve);
const MyQueryOrder = resolve => require(['@/components/profile/ShoppingOrder/MyQueryOrder'], resolve);
const MyPoint = resolve => require(['@/components/profile/MyPoint/MyPoint'], resolve);
const MyCreditLimit = resolve => require(['@/components/profile/MyCreditLimit/index'], resolve);

const MyMessage = resolve => require(['@/components/profile/MyPoint/MyMessage'], resolve);
const MyGrowth = resolve => require(['@/components/profile/MyPoint/MyGrowth'], resolve);
const UserInfo = resolve => require(['@/components/profile/AccountManagement/UserInfo'], resolve);
const SubAccountManagement = resolve => require(['@/components/profile/AccountManagement/SubAccountManagement'], resolve);
const MyMobile = resolve => require(['@/components/profile/AccountManagement/MyMobile'], resolve);
const AccountDetail = resolve => require(['@/components/profile/AccountManagement/AccountDetail'], resolve);
const MyPassword = resolve => require(['@/components/profile/AccountManagement/MyPassword'], resolve);
const ChangeInvoice = resolve => require(['@/components/profile/AccountManagement/ChangeInvoice'], resolve);
const ChangePost = resolve => require(['@/components/profile/AccountManagement/ChangePost'], resolve);
const AddCompanyInvoiceTitle = resolve => require(['@/components/profile/AccountManagement/AddCompanyInvoiceTitle'], resolve);
const MyBrowse = resolve => require(['@/components/profile/MemberPrivileges/MyBrowse'], resolve);
const myFavorite = resolve => require(['@/components/profile/MemberPrivileges/myFavorite'], resolve);
const MyComment = resolve => require(['@/components/profile/MemberPrivileges/MyComment'], resolve);
const MyLevels = resolve => require(['@/components/profile/MemberPrivileges/MyLevels'], resolve);
const AfterSaleService = resolve => require(['@/components/profile/ShoppingOrder/AfterSaleService'], resolve);
const CompanyUser = resolve => require(['@/components/signUp/CompanyUser'], resolve);
const PersonalUser = resolve => require(['@/components/signUp/PersonalUser'], resolve);
const AccountLogin = resolve => require(['@/components/Login/AccountLogin'], resolve);
const VerificationCodeLogin = resolve => require(['@/components/Login/VerificationCodeLogin'], resolve);
const QuickOrder = resolve => require(['@/pages/quickOrder/index'], resolve); // 快速下单
const ValetOrder = resolve => require(['@/pages/ValetOrder/index'], resolve);


Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/', // 首页
      name: 'Index',
      component: Index
    },
    {
      path: '/Login', // 登录
      component: Login,
      children: [
        {
          path: '/',
          name: 'VerificationCodeLogin',
          component: VerificationCodeLogin
        },
        {
          path: '/AccountLogin',
          name: 'AccountLogin',
          component: AccountLogin
        },
        {
          path: '/VerificationCodeLogin',
          name: 'VerificationCodeLogin',
          component: VerificationCodeLogin
        }
      ]
    },
    {
      path: '/SignUp', // 注册
      component: SignUp,
      children: [
        {
          path: '/',
          name: 'PersonalUser',
          component: PersonalUser
        },
        {
          path: '/companyUser',
          name: 'CompanyUser',
          component: CompanyUser
        }
      ]
    },
    {
      path: '/forgetPassword', // 找回密码
      name: 'ForgetPassword',
      component: ForgetPassword
    },
    {
      path: '/brand', // 品牌专区
      name: 'Brand',
      component: Brand
    },
    {
      path: '/brandDetail', // 品牌专区详情
      name: 'BrandDetail',
      component: BrandDetail
    },
    {
      path: '/agreementProduct', // 协议商品
      name: 'AgreementProduct',
      component: AgreementProduct
    },
    {
      path: '/industry', // 行业中心
      name: 'Industry',
      component: Industry
    },
    {
      path: '/industryDetail', // 行业中心
      name: 'IndustryDetail',
      component: IndustryDetail
    },
    {
      path: '/solutionDetails', // 行业中心
      name: 'SolutionDetails',
      component: SolutionDetails
    },
    {
      path: '/industryEquipmentDetail',
      name: 'IndustryEquipmentDetail',
      component: IndustryEquipmentDetail
    },
    {
      path: '/certificate', // 资质授权
      name: 'Certificate',
      component: Certificate
    },
    {
      path: '/invoiceDetails', // 资质授权
      name: 'InvoiceDetails',
      component: InvoiceDetails
    },
    {
      path: '/logistics', // 物流信息
      name: 'Logistics',
      component: Logistics
    },
    {
      path: '/solution', // 服务列表
      name: 'Solution',
      component: Solution
    },
    {
      path: '/solutionDetail', // 服务详情
      name: 'SolutionDetail',
      component: SolutionDetail
    },
    {
      path: '/search', // 搜索
      name: 'Search',
      component: Search
    },
    {
      path: '/about', // 走进鼎阳
      name: 'About',
      component: About
    },
    {
      path: '/news', // 走进鼎阳
      name: 'News',
      component: News
    },
    {
      path: '/topic', // 走进鼎阳
      name: 'Topic',
      component: Topic
    },
    {
      path: '/help', // 走进鼎阳
      name: 'Help',
      component: Help
    },
    {
      path: '/selfOffer', // 批量询价
      name: 'SelfOffer',
      component: SelfOffer
    },
    {
      path: '/submitOrder', // 提交订单
      name: 'SubmitOrder',
      component: SubmitOrder
    },
    {
      path: '/activity', // 活动专区
      name: 'Activity',
      component: Activity
    },
    {
      path: '/productList', // 商品列表
      name: 'ProductList',
      component: ProductList
    },
    {
      path: '/findProduct', // 商品列表
      name: 'FindProduct',
      component: FindProduct
    },
    {
      path: '/findProductList', // 商品列表
      name: 'FindProductList',
      component: FindProductList
    },
    {
      path: '/productDetail', // 商品详情
      name: 'ProductDetail',
      component: ProductDetail
    },
    {
      path: '/compareproductdetail',
      name: '/compareproductdetail',
      component: CompareProductDetail
    },
    {
      path: '/quickOrder', // 快速下单
      name: 'QuickOrder',
      component: QuickOrder
    },
    {
      path: '/shoppingCart', // 商品详情
      name: 'ShoppingCart',
      component: ShoppingCart
    },
    // {
    //   path: '/shoppingCart', // 商品详情
    //   name: 'ShoppingCart',
    //   component: ShoppingCart
    // },
    {
      path: '/placeOrder', // 订单页面
      name: 'PlaceOrder',
      component: PlaceOrder
    },
    {
      path: '/pay', // 支付页面
      name: 'Pay',
      component: Pay
    },
    {
      path: '/payOffline', // 支付页面
      name: 'payOffline',
      component: PayOffline
    },
    {
      path: '/payDone', // 支付成功页面
      name: 'PayDone',
      component: PayDone
    },
    {
      path: '/freeback', // 反馈页面
      name: 'Freeback',
      component: Freeback
    },
    {
      path: '/profile', // 主页
      component: Profile,
      children: [
        {
          path: 'personal',
          name: 'Personal',
          component: Personal
        },
        {
          path: 'basicInfomation',
          name: 'BasicInfomation',
          component: BasicInfomation
        },
        {
          path: 'myOrder',
          name: 'ProfileIndex',
          component: MyOrder
        },
        {
          path: 'viewOrderDetail',
          name: 'ViewOrderDetail',
          component: ViewOrderDetail
        },
        {
          path: 'myReceiveInfo',
          name: 'MyReceiveInfo',
          component: MyReceiveInfo
        },
        {
          path: 'myInvoiceInfo',
          name: 'MyInvoiceInfo',
          component: MyInvoiceInfo
        },
        {
          path: 'coupon',
          name: 'Coupon',
          component: Coupon
        },
        {
          path: 'myOrder',
          name: 'MyOrder',
          component: MyOrder
        },
        {
          path: 'myQueryOrder',
          name: 'MyQueryOrder',
          component: MyQueryOrder
        },
        {
          path: 'myPoint',
          name: 'MyPoint',
          component: MyPoint
        },
        {
          path: 'myCreditLimit',
          name: 'MyCreditLimit',
          component: MyCreditLimit
        },
        {
          path: 'myMessage',
          name: 'MyMessage',
          component: MyMessage
        },
        {
          path: 'myGrowth',
          name: 'MyGrowth',
          component: MyGrowth
        },
        {
          path: 'userInfo',
          name: 'UserInfo',
          component: UserInfo
        },
        {
          path: 'myMobile',
          name: 'MyMobile',
          component: MyMobile
        },
        {
          path: 'accountDetail',
          name: 'AccountDetail',
          component: AccountDetail
        },
        {
          path: 'myPassword',
          name: 'MyPassword',
          component: MyPassword
        },
        {
          path: 'subAccountManagement',
          name: 'SubAccountManagement',
          component: SubAccountManagement
        },
        {
          path: 'changeInvoice',
          name: 'ChangeInvoice',
          component: ChangeInvoice
        },
        {
          path: 'changePost',
          name: 'ChangePost',
          component: ChangePost
        },
        {
          path: 'addCompanyInvoiceTitle',
          name: 'AddCompanyInvoiceTitle',
          component: AddCompanyInvoiceTitle
        },
        {
          path: 'myFavorite',
          name: 'MyFavorite',
          component: myFavorite
        },
        {
          path: 'myComment',
          name: 'MyComment',
          component: MyComment
        },
        {
          path: 'myLevels',
          name: 'MyLevels',
          component: MyLevels
        },
        {
          path: 'myBrowse',
          name: 'MyBrowse',
          component: MyBrowse
        },
        {
          path: 'afterSaleService',
          name: 'AfterSaleService',
          component: AfterSaleService
        }
      ]
    },
    {
      path: '/merchant',
      name: 'Merchant',
      component: Merchant
    },
    {
      path: '/rate',
      name: 'Rate',
      component: Rate
    },
    {
      path: '/businessContact',
      name: 'BusinessContact',
      component: BusinessContact
    },
    {
      path: '/quickOrder',
      name: 'QuickOrder',
      component: QuickOrder
    },
    {
      path: '/valetOrder',
      name: 'ValetOrder',
      component: ValetOrder
    }
  ]
});

router.onReady(() => {
  console.log('router on ready');
});

router.beforeEach((to, from, next) => {
  if (to.path.toLowerCase() === '/login' && !to.query.redirect) {
    next({
      path: '/login',
      query: {
        redirect: from.fullPath
      }
    });
  }
  else {
    next();
  }
});

router.beforeResolve((to, from, next) => {
  console.log('router beforeResolve', to);
  next();
});

router.afterEach((to, from) => {
  console.log('router after each');
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js